import { map, reduce } from 'lodash';
import { useCallback, useMemo } from 'react';
import useTranslation from '../../components/utils/Translations/useTranslation';
const useEnumerableModel = ({ Basic, BasicSelector, BasicByValue }) => {
    const { t } = useTranslation();
    const singleModelMap = useCallback(model => 'name' in model
        ? {
            ...model,
            name: t(model.name),
        }
        : model, [t]);
    const allOptions = useMemo(() => ({
        name: t('All'),
        value: null,
    }), [t]);
    const options = useMemo(() => map(BasicSelector || Basic, (model) => Array.isArray(model)
        ? map(model, singleModelMap)
        : singleModelMap(model)), [singleModelMap, Basic, BasicSelector]);
    const optionsByValue = useMemo(() => reduce(BasicByValue, (acc, model, value) => {
        acc[value] = {
            ...model,
            name: t(model.name),
        };
        return acc;
    }, {}), [BasicByValue, t]);
    return {
        allOptions,
        options,
        optionsByValue,
    };
};
export default useEnumerableModel;
